export const COB_EXTRAS_SET_QUESTION_DATA = "COB_EXTRAS_SET_QUESTION_DATA";
export const COB_EXTRAS_SECTION_COMPLETE = "COB_EXTRAS_SECTION_COMPLETE";
export const COB_EXTRAS_COMPONENT_COMPLETE = "COB_EXTRAS_COMPONENT_COMPLETE";
